import React from "react";
import { Smartphone, Tv2, Apple, Monitor, Wifi, MessageCircle } from "lucide-react";
import VisitorCounter from "./VisitorCounter";

const WA_LINK = `https://wa.me/5588988676142?text=${encodeURIComponent("Olá! Quero testar grátis o UniPlay HD na minha Smart TV / TV Box.")}`;

export default function Footer() {
  return (
    <footer className="max-w-[1500px] mx-auto px-6 mt-20">
      <div className="rounded-2xl bg-gradient-to-br from-[#171015] via-[#0f0f12] to-[#0a0a0c] border border-white/10 p-8 md:p-10">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-3xl md:text-4xl font-extrabold leading-tight">
              Suporte <span className="uniplay-logo">UniPlay</span>
            </h3>
            <p className="text-white/65 mt-2">
              Canais travando? Clique aqui e teste Grátis em sua Smartv ou TV Box.
            </p>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#25D366] hover:brightness-110 text-white font-semibold shadow-lg shadow-[#25D366]/30 transition"
            >
              <MessageCircle className="w-4 h-4" /> FALAR NO WHATSAPP
            </a>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {[
              { icon: Smartphone, label: "Android" },
              { icon: Tv2, label: "Smart TV" },
              { icon: Apple, label: "iOS" },
              { icon: Monitor, label: "TV Box" },
              { icon: Wifi, label: "Roku" },
            ].map(({ icon: Icon, label }) => (
              <div key={label} className="p-4 rounded-xl bg-white/5 border border-white/10 hover:border-red-600/50 transition flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-red-600/15 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-red-500" />
                </div>
                <span className="text-sm font-semibold text-white/85">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="text-center py-6 text-xs text-white/40 space-y-1">
        <VisitorCounter />
      </div>
    </footer>
  );
}
